import { usePathname } from 'next/navigation';
import React, { useEffect, useState } from 'react';

import { GIFT_URL } from '../../globals';
import { getUpdatedPricingFeatureFlag, waitForAmplitudeExperimentInitialized } from '../../utils/analytics';
import { NavigationLink } from '../shared/NavigationLink';
import * as S from './Header.styles';

const Navigation = (): JSX.Element => {
  const pathname = usePathname();
  const [showGift, setShowGift] = useState(false);

  useEffect(() => {
    async function getShowGift() {
      await waitForAmplitudeExperimentInitialized(5000);
      const updatedPricingFeatureFlag = getUpdatedPricingFeatureFlag();
      if (updatedPricingFeatureFlag !== 'modest-increase') {
        setShowGift(true);
      } else {
        setShowGift(false);
      }
    }

    getShowGift();
  }, []);  


  return (
    <>
      <S.NavigationScience isActive={pathname === '/science'}>
        <NavigationLink action="Our Science Header Click" link="/science" text="Our Science" />
      </S.NavigationScience>
      <S.NavigationADHD isActive={pathname === '/adhd'}>
        <NavigationLink action="ADHD Header Click" link="/adhd" text="ADHD" />
      </S.NavigationADHD>
      <S.NavigationAbout isActive={pathname === '/about'}>
        <NavigationLink action="About Us Header Click" link="/about" text="About Us" />
      </S.NavigationAbout>
      <S.NavigationDownload isActive={pathname === '/download'}>
        <NavigationLink action="Header Download Click" link="/download" text="Download" />
      </S.NavigationDownload>
      {showGift && (
        <S.NavigationGift isActive={pathname === GIFT_URL}>
          <NavigationLink action="Gift Click" link={GIFT_URL} text="Gift" />
        </S.NavigationGift>
      )}
    </>
  );
};

export default Navigation;
